import { adminApi } from '../lib/admin-api/index.js';

export function requestJson(path, { token, method = 'GET' } = {}) {
  return adminApi.requestWithAuth({ token, path, method });
}
